import axios from 'axios';

// The customer's pay link for a job or a project, minting one if it has none
// yet (jobs billed before online payment existed). Returns the full URL.
export async function getPayLink({ requestId, projectId, token, auth }) {
  if (token) return `${window.location.origin}/pay/${token}`;
  // `auth` is the app's authHeaders() — the request config with the token.
  const res = await axios.post('/api/pay/link', { requestId, projectId }, auth);
  return `${window.location.origin}/pay/${res.data.token}`;
}

// Copy a pay link to the clipboard so it can be pasted into a text or email.
// Falls back to a prompt where the clipboard is blocked (older iOS, http).
export async function copyPayLink(args) {
  const url = await getPayLink(args);
  try {
    await navigator.clipboard.writeText(url);
    return { url, copied: true };
  } catch {
    window.prompt('Copy this pay link:', url);
    return { url, copied: false };
  }
}
